import { mapKeys, camelCase } from 'lodash'
import ReportPayrollDetail from '@/api/hr/report-payroll-detail'
import PayrollTemplate from '@/api/hr/payroll-template'
import OrgChartStructure from '@/api/hr/org-chart-structure'
import Employee from '@/api/hr/employee'
import ShiftManagement from '@/api/hr/shift-management'
import { baseState, baseMutations, Pagination } from '@/store/mixins'

export const state = {
  ...baseState,
  reportTemplates: [],
  orgChartStructures: [],
  shifts: [],
  employees: [],
  aggregate: {},
  columns: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_RESOURCES(state, { records, aggregate, columns }) {
    state.aggregate = aggregate
    state.columns = columns

    const { data, ...meta } = records
    state.resources = data
    state.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
  },

  RECEIVE_TEMPLATES(state, reportTemplates) {
    state.reportTemplates = reportTemplates
  },

  RECEIVE_ORG_CHART_STRUCTURES(state, orgChartStructures) {
    state.orgChartStructures = orgChartStructures
  },

  RECEIVE_EMPLOYEES(state, employees) {
    state.employees = employees
  },

  RECEIVE_SHIFTS(state, data) {
    state.shifts = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page || 1,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    return ReportPayrollDetail.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchTemplates(context) {
    return PayrollTemplate.get({
      params: {
        page: -1,
        fields: {
          pay_payroll_template_mains: 'template_id,template_name,template_type,is_caption1,caption1,caption1_cell,is_caption2,caption2,caption2_cell,is_caption3,caption3,caption3_cell'
        },
        filter: { template_type: 'Payroll' }
      }
    }).then(response => {
      context.commit('RECEIVE_TEMPLATES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchOrgStructures(context) {
    return OrgChartStructure.get({
      params: {
        page: -1,
        fields: {
          hris_org_chart_structure: 'org_chart_structure_id,org_chart_structure'
        }
      }
    }).then(response => {
      context.commit('RECEIVE_ORG_CHART_STRUCTURES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchShift(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        hris_shifts: 'shift_id,shift_name,shift_type'
      },
      ...attributes
    }

    return ShiftManagement.get({ params }).then(response => {
      context.commit('RECEIVE_SHIFTS', response.data)
      return Promise.resolve(response)
    })
  },

  getByPositionHierarchies(context, orgChartStructureId) {
    context.commit('RECEIVE_EMPLOYEES', [])

    if (orgChartStructureId === '' || orgChartStructureId === null) return

    return Employee.getByPositionHierarchies(orgChartStructureId).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  getEmployeeByShift(context, shiftId) {
    context.commit('RECEIVE_EMPLOYEES', [])

    if (shiftId === '' || shiftId === null) return

    return Employee.getByShift(shiftId).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  exportExcel(context, { template_id, ...attributes }) {
    return ReportPayrollDetail.exportExcel(template_id, attributes)
  }
}
